import { render, staticRenderFns } from "./ProductTextLanguagesDialog.vue?vue&type=template&id=2534faaa&scoped=true&lang=pug&"
import script from "./ProductTextLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductTextLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTextLanguagesDialog.vue?vue&type=style&index=0&id=2534faaa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2534faaa",
  null
  
)

export default component.exports